import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { VHPDataPublisher, VHPDataRetriever, ComeFrom } from '@care/mfe-data-transfer-vhp';
import { ModalMemberSelectionProps, ModalMemberSelectionCoreProps } from '@/types';
import {
  SEEKER_ENROLL,
  VERTICALS,
  MODAL_CTA_TEXTS,
  DEFAULT_VERTICAL,
  SITTER_DEFAULT_VERTICAL_DT_ENROLL,
  SITTER_MV_ENROLL,
  UNKNOWN_VERTICAL,
  SEEKER_VERTICAL_TRIAGE_PAGE_VHP,
  PROVIDER_VERTICAL_TRIAGE_PAGE_VHP,
  SOFT_INTRO_PAGE,
} from '@/constants';
import useTestFlags from '@/components/hooks/useTestFlags';
import GreaterCareModalMemberSelection from './GreaterCare/ModalMemberSelection';

function ModalMemberSelection({
  logVerticalClick,
  selectedVertical,
  selectedVerticalIcon,
  isModalOpen,
  handleModalOnClose,
}: ModalMemberSelectionProps) {
  const router = useRouter();
  const { vhpTriageProviderVertical, adultCareRoutesFlag, providerEnrollmentValueProps } =
    useTestFlags();
  const routeProviderToTriagePage = vhpTriageProviderVertical?.value === 2;
  const isAdultCareRoutesTest = adultCareRoutesFlag?.value === 2;
  const isProviderEnrollmentValueProps = providerEnrollmentValueProps?.value === 'test';

  const VHPPublisher = new VHPDataPublisher();
  const VHPRetriever = new VHPDataRetriever();
  const existingData = VHPRetriever.retrieveData();

  const isTutoringFlow = selectedVertical === VERTICALS.TUTORING;
  const {
    publicRuntimeConfig: { CZEN_GENERAL },
  } = getConfig();

  const modalButtonsText = {
    provider: MODAL_CTA_TEXTS.PROVIDER_TEXT,
    seeker: isTutoringFlow ? MODAL_CTA_TEXTS.SEEKER_TUTOR : MODAL_CTA_TEXTS.SEEKER_TEXT,
  };

  const handleDTSeeker = () => {
    const data = { ...existingData, comeFrom: ComeFrom.VHP };

    VHPPublisher.publishData(data);
    logVerticalClick('Find care');
    if (selectedVertical === DEFAULT_VERTICAL || selectedVertical === UNKNOWN_VERTICAL) {
      router.push(SEEKER_VERTICAL_TRIAGE_PAGE_VHP);
    } else {
      window.location.assign(
        `${CZEN_GENERAL}${SEEKER_ENROLL({ isAdultCareRoutesTest })[selectedVertical]}`
      );
    }
  };
  const handleDTSitter = () => {
    const data = { ...existingData, comeFrom: ComeFrom.VHP };

    VHPPublisher.publishData(data);
    logVerticalClick('Find a job');

    if (isProviderEnrollmentValueProps) {
      router.push({
        pathname: SOFT_INTRO_PAGE,
        ...(selectedVertical !== DEFAULT_VERTICAL &&
          selectedVertical !== UNKNOWN_VERTICAL && { query: { vertical: selectedVertical } }),
      });
      return;
    }

    if (selectedVertical === DEFAULT_VERTICAL || selectedVertical === UNKNOWN_VERTICAL) {
      if (routeProviderToTriagePage) {
        router.push(PROVIDER_VERTICAL_TRIAGE_PAGE_VHP);
      } else {
        window.location.assign(`${CZEN_GENERAL}${SITTER_DEFAULT_VERTICAL_DT_ENROLL}`);
      }
    } else {
      window.location.assign(`${CZEN_GENERAL}${SITTER_MV_ENROLL[selectedVertical]}`);
    }
  };

  const greaterCareMemberSelectionModalProps: ModalMemberSelectionCoreProps = {
    handleDTSeeker,
    handleDTSitter,
    handleModalOnClose,
    isModalOpen,
    modalButtonsText,
    selectedVertical,
    selectedVerticalIcon,
  };
  return <GreaterCareModalMemberSelection {...greaterCareMemberSelectionModalProps} />;
}

export default ModalMemberSelection;
